import { render } from "./Modal-App.vue?vue&type=template&id=3cb90fbf&scoped=true"
import script from "./Modal-App.vue?vue&type=script&lang=js"
export * from "./Modal-App.vue?vue&type=script&lang=js"

import "./Modal-App.vue?vue&type=style&index=0&id=3cb90fbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb90fbf"]])

export default __exports__